import React, { forwardRef, useRef, useCallback, useMemo, useImperativeHandle } from 'react';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.esm.js';

var NoFieldsSelectedWarning = /*#__PURE__*/forwardRef(function (props, ref) {
  var resources = props.resources,
    _props$fontSize = props.fontSize,
    fontSize = _props$fontSize === void 0 ? 'sm' : _props$fontSize;
  var confirmationDialogRef = useRef(null);
  var open = useCallback(function () {
    var _confirmationDialogRe;
    (_confirmationDialogRe = confirmationDialogRef.current) === null || _confirmationDialogRe === void 0 ? void 0 : _confirmationDialogRe.open();
  }, []);
  var close = useCallback(function () {
    var _confirmationDialogRe2;
    (_confirmationDialogRe2 = confirmationDialogRef.current) === null || _confirmationDialogRe2 === void 0 ? void 0 : _confirmationDialogRe2.close();
  }, []);
  var isOpen = useMemo(function () {
    var _confirmationDialogRe3;
    return ((_confirmationDialogRe3 = confirmationDialogRef.current) === null || _confirmationDialogRe3 === void 0 ? void 0 : _confirmationDialogRe3.isOpen) === true;
  }, []);
  useImperativeHandle(ref, function () {
    return {
      open: open,
      close: close,
      isOpen: isOpen
    };
  });
  return /*#__PURE__*/React.createElement(ConfirmationDialog, {
    ref: confirmationDialogRef,
    resources: resources,
    onConfirm: close,
    fontSize: fontSize
  });
});
NoFieldsSelectedWarning.displayName = 'NoFieldsSelectedWarning';

export { NoFieldsSelectedWarning };
//# sourceMappingURL=no-fields-selected-warning.esm.js.map
